var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"account"}},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"left"},[_c('loginSafe'),_c('devAddress')],1),_c('div',{staticClass:"right"},[_c('socialBind'),_c('loginLog')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }